var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-button-bar"},[_c('img',{staticClass:"top",attrs:{"src":require('@/assets/images/sideButtonBar/up.png')}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('img',{staticClass:"bottom",attrs:{"src":require('@/assets/images/sideButtonBar/down.png')}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-557ac0a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideButtonBar.vue
// module id = null
// module chunks = 